import Results from './DocumentSection/Results';
import Header from './DocumentSection/Header';
import Section from './Section'

function DocumentSection() {

    return (
        <Section header={<Header />} >
            <Results />
        </Section>
    )
}

export default DocumentSection;